var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeCaixaP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4453 30.5884H23.752V37.2786H10.4453V30.5884Z",
    fill: "#2544B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4453 63.1465C10.4453 64.4414 11.4941 65.4902 12.7891 65.4902H21.4082C22.7031 65.4902 23.752 64.4414 23.752 63.1465V40.2188H10.4453V63.1465Z",
    fill: "#2544B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8074 14.8792C21.8074 14.0799 21.4008 13.3358 20.727 12.9046L16.0055 9.88229C14.4457 8.88386 12.3984 10.0042 12.3984 11.8569V27.6479H21.8074V14.8792Z",
    fill: "#2544B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4424 57.2754V59.9074C29.4424 62.9953 31.942 65.4797 35.0146 65.4797H58.9818C62.0545 65.4797 64.5541 62.9953 64.5541 59.9074V57.2754H29.4424Z",
    fill: "#2544B1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8238 54.334H57.1594C60.777 51.2754 63.0703 46.5855 63.0703 41.3215C63.0703 32.0285 55.8797 24.4863 46.9992 24.4863C38.1035 24.4863 30.9141 32.0297 30.9141 41.3215C30.9129 46.5855 33.2215 51.2754 36.8238 54.334ZM53.5559 38.7926C54.1289 39.3656 54.1289 40.2926 53.5559 40.8656L47.6449 46.7766C47.3508 47.0707 46.9828 47.2031 46.6008 47.2031C46.2328 47.2031 45.8508 47.0707 45.5566 46.7766C44.9836 46.2035 44.9836 45.2766 45.5566 44.7035L51.4676 38.7926C52.0418 38.2195 52.9688 38.2195 53.5559 38.7926ZM40.4262 39.5719L46.3371 33.6609C46.9102 33.0879 47.8512 33.0879 48.4254 33.6609C48.9984 34.234 48.9984 35.1609 48.4254 35.734L42.5145 41.6449C42.2203 41.9391 41.8523 42.0715 41.4703 42.0715C41.1023 42.0715 40.7203 41.9391 40.4262 41.6449C39.8531 41.0719 39.8531 40.1449 40.4262 39.5719Z",
    fill: "#2544B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeCaixaP);
export default __webpack_public_path__ + "static/media/icone-caixa-p.07cc4b05d90ffa4cabc7776c7ac99375.svg";
export { ForwardRef as ReactComponent };